import React, { useState } from "react";
import { CancelButton, SaveButton, DrawerComponent } from "@comps/components";
import { makeRequest, notify } from "@utils/helpers";
import { createClinicReq } from "../requests";
import ClinicForm from "./ClinicForm";

const formName = "clinics";
const CreateClinic = (props) => {
  const [loader, setLoader] = useState(false);
  const [errors, setErrors] = useState([]);

  const onFinish = (data) => {
    let payload = {
      "object": {
        ...data
      }
    }
    makeRequest(setLoader, createClinicReq, payload, onSuccess, onError);
  }

  const onSuccess = (data, res) => {
    notify("Clinic Created", res.msg);
    props.onCreated(data.object);
  }

  const onError = (data) => {
    setErrors(data);
  }

  return (
    <DrawerComponent mainTitle="Create" subTitle="Clinic" open={ true } footer={ false } onClose={ () => props.onClosed(false) }>
      <ClinicForm setErrors={ setErrors } errors={ errors } onFinish={ onFinish } formName={ formName } />
      <div className="form-actions">
        <CancelButton key="close_button" onClick={ () => props.onClosed(false) } />
        <SaveButton form={ formName } key="create_button" htmlType="submit" state={ loader } />
      </div>
    </DrawerComponent>
  );
}

export default CreateClinic
